<template>
    <div class="modalM" :class="[{'show' : show}, {'hide' : !show}]">
        <button @click="() => $emit('close')" class="fixed w-full h-full z-10 left-0 top-0 bg-gray-5 dark:bg-gray-11 opacity-75"></button>

        <div class="px-5 relative z-20 w-full">
            <div class="modal-content dark:!bg-gray-12">
                <div class="flex items-center w-full">
                    <button @click="() => $emit('close')" class="text-gray ml-auto mr-2 mt-2">
                        <churchapp-icons class="!w-5 text-gray-3" icon="x-mark" />
                    </button>
                </div>

                <div class="modal-body flex flex-col items-center dark:text-white">
                    <div v-if="icon" class="modal-icon mb-2">
                        <churchapp-icons class="!w-24 !h-auto block !text-red" :icon="icon" />
                    </div>

                    <h1 class="text-2xl font-medium mb-2">{{title}}</h1>
                    <p class="text-sm">{{description}}</p>


                    <slot></slot>
                </div>

                <div
                    v-if="!hideFooter" 
                    class="w-full grid grid-cols-2 gap-4 mt-10 px-5 pb-3">
                    <button v-if="!hideCancel" @click="() => $emit('close')" class="!text-sm !px-3 !py-1 btn btn-primary-outline">{{cancelLabel ?? 'Cancel'}}</button>
                    <button v-if="!hideContinue" @click="() => $emit('continue')" class="!text-sm !px-3 !py-1 btn btn-secondary !mt-0 !min-h-full">{{continueLabel ?? 'Continue'}}</button>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import churchappIcons from './churchappIcons.vue'
export default {
  components: { churchappIcons },
    name : 'Modal',
    props : {
        hideCancel : {
            type : Boolean,
            default : () => false
        },
        hideContinue : {
            type : Boolean,
            default : () => false
        },
        hideFooter : {
            type : Boolean,
            default : () => false
        },
        icon : {
            type   : String,
            default: () => null
        },
        title : {
            type : String,
            default : () => null
        },
        description : {
            type : String,
            default : () => null
        },
        cancelLabel : {
            type :  String,
            default :() => null
        },
        continueLabel : {
            type : String,
            default : () => null
        },
        show : {
            type   : Boolean,
            default: () => false
        }
    }
}
</script>